import axios from '@/jslib/axios'

export const getFreeTripList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/free/round/list',
    params,
    ...other
  })
}
